import { defaultCtx } from "~/lib/AjaxCtx"

export class AdminService {
    constructor(ctx = defaultCtx) {
        this.$http = ctx
    }

    getPanel() {
        return this.$http.fetchData("admin/panel")
    }
}

export function makeActions(service = new AdminService()) {
    return {
        async init({ commit }) {
            const panel = await service.getPanel()
            commit("setPanel", panel)
        },
    }
}

export default {
    namespaced: true,

    state: {
        canEditSubdomain: false,
        canPersonalizePlatform: false,
        canManageDomain: false,
    },

    getters: {
        hasAdminPanel(state) {
            return state.canEditSubdomain || state.canPersonalizePlatform
        },
    },

    mutations: {
        clearModule(state) {
            state.canEditSubdomain = false
            state.canPersonalizePlatform = false
            state.canManageDomain = false
        },

        setPanel(
            state,
            { canEditSubdomain, canPersonalizePlatform, canManageDomain }
        ) {
            state.canEditSubdomain = canEditSubdomain
            state.canPersonalizePlatform = canPersonalizePlatform
            state.canManageDomain = canManageDomain
        },
    },
    actions: makeActions(),
}
